import { apiAction, apiFetch, getMetaContent } from 'utils';
import DuckEntity from './DuckEntity';

const duck = new DuckEntity('sharedPortalGroups');

const save = ({ sharedPortalGroup, logoFile, backgroundFile }) => {
  const token = getMetaContent('csrf-token');

  const headers = { Accept: 'application/json', 'X-CSRF-Token': token };
  const data = new FormData();
  data.append('shared_portal_group', JSON.stringify(sharedPortalGroup));

  if (logoFile) {
    data.append('custom_logo', logoFile);
  }

  if (backgroundFile) {
    data.append('custom_background', backgroundFile);
  }

  const actionParams = { shared_portal_group: sharedPortalGroup, custom_logo: logoFile, custom_background: backgroundFile }

  return apiAction(
    duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
    (state) => {
      if (sharedPortalGroup.id) {
        return apiFetch.put(state, duck.config.entityApiPath(sharedPortalGroup.id), null, { rawBody: data, headers })
      } else {
        return apiFetch.post(state, duck.config.collectionApiPath(), null, { rawBody: data, headers })
      }
    },
    actionParams
  );
};

export const sharedPortalGroups = {
  ...duck,
  actions: {
    ...duck.actions,
    save
  }
};

export default sharedPortalGroups.reducer;
